interface DownloadOptionValue {
  price?: number | string | null;
}

interface DownloadOption {
  values?: DownloadOptionValue[] | null;
}

export function hasPaidDownloadOptions(
  downloads: DownloadOption[] | null | undefined
): boolean {
  return downloads?.some((download) =>
    download.values?.some((value) => {
      const price = Number.parseFloat(value.price?.toString() || '0');
      return Number.isFinite(price) && price > 0;
    })
  ) || false;
}
